import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { post } from '../http';
import { activeSnack } from './common';

// --- API THUNKS START ---

export const getAllPortfolioAdManager = createAsyncThunk(
  'AdManager/portfolio/list',
  async ({ credentials }) => {
    try {
      const URL = `portfolio/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials?.state);

      if (response) {
        return {
          page: response?.page,
          adsManager: response?.portfolios,
          total: response?.total,
        };
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllCampaignAdManager = createAsyncThunk(
  'AdManager/campaign/list',
  async ({ credentials }) => {
    try {
      const URL = `campaign/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;
      const response = await post(URL, credentials?.state);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.campaigns,
          total: response?.total,
        };
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllAdGroupAdManager = createAsyncThunk(
  'AdManager/adGroup/list',
  async ({ credentials }) => {
    try {
      const URL = `ad-group/advertiser/all?page=${credentials?.page || 1}&search=${
        credentials?.search || ''
      }&limit=${credentials?.limit || 25}&from=${credentials?.date?.from || ''}&to=${
        credentials?.date?.to || ''
      }`;
      const response = await post(URL, credentials?.state);

      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.adGroups,
          total: response?.total,
        };
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllTargetAdManager = createAsyncThunk(
  'AdManager/target/list',
  async ({ credentials }) => {
    try {
      const URL = `targeting-clause/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;
      const response = await post(URL, credentials.state);
      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.targetingClauses,
          total: response?.total,
        };
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllNegativeTargetAdManager = createAsyncThunk(
  'AdManager/negative-target/list',
  async ({ credentials }) => {
    try {
      const URL = `negative-targeting-clause/advertiser/all?page=${credentials?.page || ''}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials.state);
      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.negativeTargetingClauses,
          total: response?.total,
        };
      }
      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllSearchTermAdManager = createAsyncThunk(
  'AdManager/search-term/list',
  async ({ searchTermCredentials, query }) => {
    try {
      const URL = `analytics/advertiser/search-term?page=${query?.page || 1}&limit=${
        query?.limit || 25
      }&from=${query?.date?.from || ''}&to=${query?.date?.to || ''}`;

      const response = await post(URL, searchTermCredentials);
      console.log(response);
      if (response) {
        return response;
      }
      return query?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      query?.dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllProductsAdManager = createAsyncThunk(
  'AdManager/product/list',
  async ({ credentials }) => {
    try {
      const URL = `product-ad/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials.state);
      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.productAds,
          total: response?.total,
        };
      }

      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllKeywordAdManager = createAsyncThunk(
  'AdManager/keyword/list',
  async ({ credentials }) => {
    try {
      const URL = `keyword/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials?.state);
      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.keywords,
          total: response?.total,
        };
      }

      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

export const getAllNegativeKeywordAdManager = createAsyncThunk(
  'AdManager/negative-keyword/list',
  async ({ credentials }) => {
    try {
      const URL = `negative-keyword/advertiser/all?page=${credentials?.page || 1}&limit=${
        credentials?.limit || 25
      }&from=${credentials?.date?.from || ''}&to=${credentials?.date?.to || ''}&search=${
        credentials?.search || ''
      }`;

      const response = await post(URL, credentials?.state);
      console.log(response);
      if (response) {
        return {
          page: response?.page,
          adsManager: response?.negativeKeywords,
          total: response?.total,
        };
      }

      return credentials?.dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      credentials?.dispatch(
        activeSnack({ type: 'error', message: error?.response?.data?.message })
      );
      throw error?.response?.data?.message;
    }
  }
);

// --- REDUX SLICE START ---

export const AdManagerSlice = createSlice({
  name: 'admanager',
  initialState: {
    loading: false,
    error: {},
    allAdManagerList: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    // get all portfolio analytics
    [getAllPortfolioAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllPortfolioAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllPortfolioAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // all campaign analytics
    [getAllCampaignAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllCampaignAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllCampaignAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // all ad-group analytics
    [getAllAdGroupAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllAdGroupAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllAdGroupAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // all target analytics

    [getAllTargetAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllTargetAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllTargetAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // all neg-target analytics

    [getAllNegativeTargetAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllNegativeTargetAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllNegativeTargetAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // all search-term analytics

    [getAllSearchTermAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllSearchTermAdManager.fulfilled]: (state, action) => {
      state.loading = false;
      state.allAnalytics = action.payload;
      state.error = {};
    },
    [getAllSearchTermAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // all search-term analytics

    [getAllProductsAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllProductsAdManager.fulfilled]: (state, action) => {
      console.log(action.payload);

      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllProductsAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllKeywordAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllKeywordAdManager.fulfilled]: (state, action) => {
      console.log(action.payload);

      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllKeywordAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllNegativeKeywordAdManager.pending]: (state) => {
      state.loading = true;
    },
    [getAllNegativeKeywordAdManager.fulfilled]: (state, action) => {
      console.log(action.payload);

      state.loading = false;
      state.allAdManagerList = action.payload;
      state.error = {};
    },
    [getAllNegativeKeywordAdManager.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = AdManagerSlice.actions;

export default AdManagerSlice.reducer;
